module.exports = "<div class=\"spinner-wrapper\">\n    <svg class=\"spinner\" width=\"65px\" height=\"65px\" viewBox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\">\n       <circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle>\n    </svg>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/news/spinner/spinner.component.html
// module id = ./src/app/components/news/spinner/spinner.component.html
// module chunks = main